export default __webpack_public_path__ + "static/media/21.2f85d819.wav";